// ============================================
// FILE: /frontend/src/api/subscriptions.api.js
// PURPOSE: Subscriptions API endpoints
// ============================================

import apiClient from './client.js';

export const subscriptionsAPI = {
  // Get all subscriptions (admin only)
  getAllSubscriptions: async (params = {}) => {
    console.log('[subscriptionsAPI] Fetching all subscriptions (admin) with params:', params);
    try {
      const response = await apiClient.get('/admin/subscriptions', { params });
      console.log('[subscriptionsAPI] Fetched', response.data.users?.length || 0, 'subscriptions');
      return response.data;
    } catch (error) {
      console.error('[subscriptionsAPI] Error fetching subscriptions:', error);
      throw error;
    }
  },

  // Get subscription stats (admin only)
  getSubscriptionStats: async () => {
    console.log('[subscriptionsAPI] Fetching subscription stats (admin)');
    try {
      const response = await apiClient.get('/admin/subscriptions/stats');
      console.log('[subscriptionsAPI] Stats fetched successfully');
      return response.data;
    } catch (error) {
      console.error('[subscriptionsAPI] Error fetching stats:', error);
      throw error;
    }
  }
};